import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/Home'
import Index from '../view/Index'
import Mine from '../view/mine/Mine'
import Install from '../view/mine/Install'
import ModifyNickname from '../view/mine/ModifyNickname'
import RegisterStepOne from '../view/register/StepOne'
import RegisterStepTwo from '../view/register/StepTwo'
import ForgetPassword from '../view/ForgetPassword'
import AddressList from '../view/mine/AddressList'
import AddressEdit from '../view/mine/AddressEdit'
import CustomerCart from '../view/customer/CustomerCart'
import CustomerVisitReservation from '../view/customer/CustomerVisitReservation'
import CustomerFavoriteList from '../view/customer/CustomerFavoriteList'
import CustomerEvaluateEdit from '../view/customer/CustomerEvaluateEdit'
import Login from '../view/Login'
import Auth from '../view/Auth'
import BindPhone from '../view/BindPhone'
import MineAppointment from '../view/mine/MineAppointment'
import MineProject from '../view/mine/MineProject'
import MinePublish from '../view/mine/MinePublish'
import MineActivity from '../view/mine/MineActivity'
import OnestopProjectDetail from '../view/mine/OnestopProjectDetail'
import AppointmentDetail from '../view/mine/AppointmentDetail'
import AppointmentCancelCheckDetail from '../view/mine/AppointmentCancelCheckDetail'
import LinkedProjectDetail from '../view/mine/LinkedProjectDetail'
import ForemanProjectDetail from '../view/mine/ForemanProjectDetail'
import DecorationLive from '../view/mine/DecorationLive'
import LinkedProjectStageFee from '../view/mine/LinkedProjectStageFee'
import ConfirmPayLinkedBill from '../view/mine/ConfirmPayLinkedBill'
import SupervisorSeek from '../view/supervisor/SupervisorSeek'
import SupervisorDetail from '../view/supervisor/SupervisorDetail'
import SupervisorReservation from '../view/supervisor/SupervisorReservation'
import DesignerList from '../view/designer/DesignerList'
import DesignerDetail from '../view/designer/DesignerDetail'
import DesignerReservation from '../view/designer/DesignerReservation'
import GangmasterSeek from '../view/gangmaster/GangmasterSeek'
import GangmasterSeekSearch from '../view/gangmaster/GangmasterSeekSearch'
import GangmasterDetail from '../view/gangmaster/GangmasterDetail'
import GangmasterReservation from '../view/gangmaster/GangmasterReservation'
import CleanerList from '../view/cleaner/CleanerList'
import CleanerDetail from '../view/cleaner/CleanerDetail'
import MoverList from '../view/mover/MoverList'
import MoverDetail from '../view/mover/MoverDetail'
import PuncherList from '../view/puncher/PuncherList'
import PuncherDetail from '../view/puncher/PuncherDetail'
import WorkerList from '../view/worker/WorkerList'
import WorkerDetail from '../view/worker/WorkerDetail'
import CaseList from '../view/case/CaseList'
import CompanyCaseList from '../view/case/CompanyCaseList'
import Project from '../view/case/Project'
import CompanyProject from '../view/case/CompanyProject'
import ConfirmPaymentOnestop from '../view/mine/ConfirmPaymentOnestop'
import ConfirmPaymentForeman from '../view/mine/ConfirmPaymentForeman'
import OnestopSetMeal from '../view/onestop/OnestopSetMeal'
import OnestopDetail from '../view/onestop/OnestopDetail'
import OnestopCompanyDetail from '../view/onestop/OnestopCompanyDetail'
import OnestopCompany from '../view/onestop/OnestopCompany'
import OnestopReservation from '../view/onestop/OnestopReservation'
import OnestopNearbySite from '../view/onestop/OnestopNearBySite'
import OnestopProjectNodeList from '../view/onestop/OnestopProjectNodeList'
import ShopList from '../view/shop/List'
import ShopDetail from '../view/shop/Detail'
import ShopQrcode from '../view/shop/Qrcode'
import StoreList from '../view/store/List'
import StoreShopList from '../view/store/ShopList'
import StoreShopDetail from '../view/store/ShopDetail'
import ProductDetail from '../view/product/Detail'
import ActivityList from '../view/activity/List'
import ActivityDetail from '../view/activity/Detail'
import ActivityEnroll from '../view/activity/Enroll'
import ActivityShop from '../view/activity/Shop'
import ActivityProduct from '../view/activity/Product'
import ActivitySupervisor from '../view/activity/Supervisor'
import ArticleList from '../view/article/List'
import ArticleDetail from '../view/article/Detail'
import TradeOrderList from '../view/trade/OrderList'
import TradeOrderDetail from '../view/trade/OrderDetail'
import TradeOfflineList from '../view/trade/OfflineList'
import TradeOfflineDetail from '../view/trade/OfflineDetail'
import OfflineDeposit from '../view/trade/OfflineDeposit'
import OfflineTailMoney from '../view/trade/OfflineTailMoney'
import OfflineRefund from '../view/trade/OfflineRefund'
import OfflinePayVoucher from '../view/trade/OfflinePayVoucher'
import Settlement from '../view/trade/Settlement'
import QaList from '../view/qa/List'
import QaDetail from '../view/qa/Detail'
import QaEdit from '../view/qa/Edit'
import AnswerDetail from '../view/qa/AnswerDetail'
import DesignerCaseList from '../view/case/DesignerCaseList'
import OnestopCompanyList from '../view/onestop/OnestopCompanyList'
import SupervisorIntro from '../view/supervisor/SupervisorIntro'
import SupervisorDesignerIntro from '../view/supervisor/SupervisorDesignerIntro'
import OrderRefund from '../view/trade/OrderRefund'
import DealerVerifierRegister from '../view/DealerVerifierRegister'
import DealerVerifyCoupon from '../view/DealerVerifyCoupon.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: 'index',
      children: [
        {
          path: 'index',
          name: 'Index',
          component: Index,
          meta: {
            title: '水木家居',
          }
        },
        {
          path: 'customer/cart',
          name: 'CustomerCart',
          component: CustomerCart,
          meta: {
            title: '购物车',
            authBindPhone: true,
          }
        },
        {
          path: 'mine',
          name: 'Mine',
          component: Mine,
          meta: {
            title: '我的',
            authBindPhone: true,
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录',
      }
    },
    {
      path: '/bind/phone',
      name: 'BindPhone',
      component: BindPhone,
      meta: {
        title: '绑定手机号',
      }
    },
    {
      path: '/mine/install',
      name: 'Install',
      component: Install,
      meta: {
        title: '设置',
      }
    },
    {
      path: '/mine/modify/nickname',
      name: 'ModifyNickname',
      component: ModifyNickname,
      meta: {
        title: '修改昵称',
      }
    },
    {
      path: '/register/stepOne',
      name: 'RegisterStepOne',
      component: RegisterStepOne,
      meta: {
        title: '注册',
      }
    },
    {
      path: '/register/stepTwo',
      name: 'RegisterStepTwo',
      component: RegisterStepTwo,
      meta: {
        title: '注册',
      }
    },
    {
      path: '/forget/password',
      name: 'ForgetPassword',
      component: ForgetPassword,
      meta: {
        title: '忘记密码',
      }
    },
    {
      path: '/mine/address/list',
      name: 'AddressList',
      component: AddressList,
      meta: {
        title: '\u200E',
        authBindPhone: true,
      }
    },
    {
      path: '/mine/address/edit',
      name: 'AddressEdit',
      component: AddressEdit,
      meta: {
        title: '添加新地址',
        authBindPhone: true,
      }
    },
    {
      path: '/gangmaster/seek',
      name: 'GangmasterSeek',
      component: GangmasterSeek,
      meta: {
        title: '优选工长',
      }
    },
    {
      path: '/gangmaster/seek/search',
      name: 'GangmasterSeekSearch',
      component: GangmasterSeekSearch,
      meta: {
        title: '工长搜索',
      }
    },
    {
      path: '/gangmaster/detail',
      name: 'GangmasterDetail',
      component: GangmasterDetail,
      meta: {
        title: '工长详情',
      }
    },
    {
      path: '/supervisor/seek',
      name: 'SupervisorSeek',
      component: SupervisorSeek,
      meta: {
        title: '\u200E',
      }
    },
    {
      path: '/supervisor/detail',
      name: 'SupervisorDetail',
      component: SupervisorDetail,
      meta: {
        title: '监理详情',
      }
    },
    {
      path: '/case/list',
      name: 'CaseList',
      component: CaseList,
      meta: {
        title: '装修案例',
      }
    },
    {
      path: '/company/case/list',
      name: 'CompanyCaseList',
      component: CompanyCaseList,
      meta: {
        title: '装修案例',
      }
    },
    {
      path: '/designer/case/list',
      name: 'DesignerCaseList',
      component: DesignerCaseList,
      meta: {
        title: '装修案例',
      }
    },
    {
      path: '/project',
      name: 'Project',
      component: Project,
      meta: {
        title: '案例详情',
      }
    },
    {
      path: '/company/project',
      name: 'CompanyProject',
      component: CompanyProject,
      meta: {
        title: '案例详情',
      }
    },
    {
      path: '/trade/offline/gangmaster',
      name: 'GangmasterReservation',
      component: GangmasterReservation,
      meta: {
        title: '预约工长',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/supervisor',
      name: 'SupervisorReservation',
      component: SupervisorReservation,
      meta: {
        title: '预约管家',
        authBindPhone: true,
      }
    },
    {
      path: '/supervisor/intro',
      name: 'SupervisorIntro',
      component: SupervisorIntro,
      meta: {
        title: '独立监理',
      }
    },
    {
      path: '/supervisor/designer/intro',
      name: 'SupervisorDesignerIntro',
      component: SupervisorDesignerIntro,
      meta: {
        title: '独立设计师',
      }
    },
    {
      path: '/designer/list',
      name: 'DesignerList',
      component: DesignerList,
      meta: {
        title: '优选设计',
      }
    },
    {
      path: '/designer/detail',
      name: 'DesignerDetail',
      component: DesignerDetail,
      meta: {
        title: '设计师详情',
      }
    },
    {
      path: '/trade/offline/designer',
      name: 'DesignerReservation',
      component: DesignerReservation,
      meta: {
        title: '预约设计师',
        authBindPhone: true,
      }
    },
    {
      path: '/cleaner/list',
      name: 'CleanerList',
      component: CleanerList,
      meta: {
        title: '优选保洁',
        authBindPhone: true,
      }
    },
    {
      path: '/cleaner/detail',
      name: 'CleanerDetail',
      component: CleanerDetail,
      meta: {
        title: '保洁详情',
        authBindPhone: true,
      }
    },
    {
      path: '/mover/list',
      name: 'MoverList',
      component: MoverList,
      meta: {
        title: '优选搬家',
        authBindPhone: true,
      }
    },
    {
      path: '/mover/detail',
      name: 'MoverDetail',
      component: MoverDetail,
      meta: {
        title: '搬家详情',
        authBindPhone: true,
      }
    },
    {
      path: '/puncher/detail',
      name: 'PuncherDetail',
      component: PuncherDetail,
      meta: {
        title: '打孔详情',
        authBindPhone: true,
      }
    },
    {
      path: '/puncher/list',
      name: 'PuncherList',
      component: PuncherList,
      meta: {
        title: '优选打孔',
        authBindPhone: true,
      }
    },
    {
      path: '/worker/list',
      name: 'WorkerList',
      component: WorkerList,
      meta: {
        title: '施工工人',
      }
    },
    {
      path: '/worker/detail',
      name: 'WorkerDetail',
      component: WorkerDetail,
      meta: {
        title: '工人详情',
      }
    },
    {
      path: '/mine/appointment',
      name: 'MineAppointment',
      component: MineAppointment,
      meta: {
        title: '我的预约',
        authBindPhone: true,
      }
    },
    {
      path: '/mine/publish',
      name: 'MinePublish',
      component: MinePublish,
      meta: {
        title: '我的发布',
        authBindPhone: true,
      }
    },
    {
      path: '/mine/project',
      name: 'MineProject',
      component: MineProject,
      meta: {
        title: '我的项目',
        authBindPhone: true,
      }
    },
    {
      path: '/onestop/project/detail',
      name: 'OnestopProjectDetail',
      component: OnestopProjectDetail,
      meta: {
        title: '项目详情',
        authBindPhone: true,
      }
    },
    {
      path: '/linked/project/detail',
      name: 'LinkedProjectDetail',
      component: LinkedProjectDetail,
      meta: {
        title: '项目详情',
      }
    },
    {
      path: '/foreman/project/detail',
      name: 'ForemanProjectDetail',
      component: ForemanProjectDetail,
      meta: {
        title: '项目详情',
      }
    },
    {
      path: '/decoration/live',
      name: 'DecorationLive',
      component: DecorationLive,
      meta: {
        title: '工地直播',
      }
    },
    {
      path: '/linked/project/stage',
      name: 'LinkedProjectStageFee',
      component: LinkedProjectStageFee,
      meta: {
        title: '项目账单详情',
      }
    },
    {
      path: '/treade/offline/linked',
      name: 'ConfirmPayLinkedBill',
      component: ConfirmPayLinkedBill,
      meta: {
        title: '项目账单详情',
      }
    },
    {
      path: '/appointment/detail',
      name: 'AppointmentDetail',
      component: AppointmentDetail,
      meta: {
        title: '我的预约',
        authBindPhone: true,
      }
    },
    {
      path: '/appointment/cancel/check/detail',
      name: 'AppointmentCancelCheckDetail',
      component: AppointmentCancelCheckDetail,
      meta: {
        title: '预约取消审核',
      }
    },
    {
      path: '/trade/offline/onestop',
      name: 'ConfirmPaymentOnestop',
      component: ConfirmPaymentOnestop,
      meta: {
        title: '确认支付',
        authBindPhone: true,
      }
    },
    {
      path: '/confirm/payment/foreman',
      name: 'ConfirmPaymentForeman',
      component: ConfirmPaymentForeman,
      meta: {
        title: '确认支付',
        authBindPhone: true,
      }
    },
    {
      path: '/onestop/set/meal',
      name: 'OnestopSetMeal',
      component: OnestopSetMeal,
      meta: {
        title: '优选装修',
      }
    },
    {
      path: '/onestop/company',
      name: 'OnestopCompany',
      component: OnestopCompany,
      meta: {
        title: '\u200E',
      }
    },
    {
      path: '/onestop/detail',
      name: 'OnestopDetail',
      component: OnestopDetail,
    },
    {
      path: '/onestop/companyDetail',
      name: 'OnestopCompanyDetail',
      component: OnestopCompanyDetail,
    },
    {
      path: '/trade/offline/onestopOppintment',
      name: 'OnestopReservation',
      component: OnestopReservation,
      meta: {
        title: '预约装修',
        authBindPhone: true,
      }
    },
    {
      path: '/onestop/nearbySite',
      name: 'OnestopNearbySite',
      component: OnestopNearbySite,
      meta: {
        title: '附近工地',
      }
    },
    {
      path: '/onestop/project/node/list',
      name: 'OnestopProjectNodeList',
      component: OnestopProjectNodeList,
      meta: {
        title: '项目阶段',
      }
    },
    {
      path: '/shop/list',
      name: 'ShopList',
      component: ShopList,
      meta: {
        title: '水木商城',
      }
    },
    {
      path: '/shop/detail',
      name: 'ShopDetail',
      component: ShopDetail,
      meta: {
        title: '店铺详情',
      }
    },
    {
      path: '/shop/qrcode',
      name: 'ShopQrcode',
      component: ShopQrcode,
      meta: {
        title: '咨询',
      }
    },
    {
      path: '/store/list',
      name: 'StoreList',
      component: StoreList,
      meta: {
        title: '主材卖场',
      }
    },
    {
      path: '/store/shop/list',
      name: 'StoreShopList',
      component: StoreShopList,
      meta: {
        title: '水木商城',
      }
    },
    {
      path: '/store/shop/detail',
      name: 'StoreShopDetail',
      component: StoreShopDetail,
      meta: {
        title: '店铺详情',
      }
    },
    {
      path: '/product/detail',
      name: 'ProductDetail',
      component: ProductDetail,
      meta: {
        title: '宝贝详情',
      }
    },
    {
      path: '/activity/list',
      name: 'ActivityList',
      component: ActivityList,
      meta: {
        title: '活动中心',
      }
    },
    {
      path: '/activity/detail',
      name: 'ActivityDetail',
      component: ActivityDetail,
      meta: {
        title: '活动详情',
        authBindPhone: true,
      }
    },
    {
      path: '/activity/enroll',
      name: 'ActivityEnroll',
      component: ActivityEnroll,
      meta: {
        title: '活动报名',
        authBindPhone: true,
      }
    },
    {
      path: '/activity/shop',
      name: 'ActivityShop',
      component: ActivityShop,
      meta: {
        title: '活动店铺',
      }
    },
    {
      path: '/activity/product',
      name: 'ActivityProduct',
      component: ActivityProduct,
      meta: {
        title: '活动商品',
      }
    },
    {
      path: '/activity/supervisor',
      name: 'ActivitySupervisor',
      component: ActivitySupervisor,
    },
    {
      path: '/article/list',
      name: 'ArticleList',
      component: ArticleList,
      meta: {
        title: '装修百科',
      }
    },
    {
      path: '/article/detail',
      name: 'ArticleDetail',
      component: ArticleDetail,
      meta: {
        title: '文章详情',
      }
    },
    {
      path: '/trade/order/list',
      name: 'TradeOrderList',
      component: TradeOrderList,
      meta: {
        title: '商城订单',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/order/detail',
      name: 'TradeOrderDetail',
      component: TradeOrderDetail,
      meta: {
        title: '订单详情',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/list',
      name: 'TradeOfflineList',
      component: TradeOfflineList,
      meta: {
        title: '团购订单',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/detail',
      name: 'TradeOfflineDetail',
      component: TradeOfflineDetail,
      meta: {
        title: '订单详情',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/deposit',
      name: 'OfflineDeposit',
      component: OfflineDeposit,
      meta: {
        title: '支付订金',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/tailMoney',
      name: 'OfflineTailMoney',
      component: OfflineTailMoney,
      meta: {
        title: '支付全款',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/refund',
      name: 'OfflineRefund',
      component: OfflineRefund,
      meta: {
        title: '退订金申请',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/order/refund',
      name: 'OrderRefund',
      component: OrderRefund,
      meta: {
        title: '申请退款',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/offline/pay/voucher',
      name: 'OfflinePayVoucher',
      component: OfflinePayVoucher,
      meta: {
        title: '上传合同凭证',
        authBindPhone: true,
      }
    },
    {
      path: '/trade/settlement',
      name: 'Settlement',
      component: Settlement,
      meta: {
        title: '提交订单',
        authBindPhone: true,
      }
    },
    {
      path: '/qa/list',
      name: 'QaList',
      component: QaList,
      meta: {
        title: '讨论区',
      }
    },
    {
      path: '/qa/edit',
      name: 'QaEdit',
      component: QaEdit,
      meta: {
        title: '新的问题',
        authBindPhone: true,
      }
    },
    {
      path: '/qa/answer/detail',
      name: 'AnswerDetail',
      component: AnswerDetail,
      meta: {
        title: '评论详情',
        authBindPhone: true,
      }
    },
    {
      path: '/qa/detail',
      name: 'QaDetail',
      component: QaDetail,
      meta: {
        title: '问答详情',
      }
    },
    {
      path: '/customer/visit/reservation',
      name: 'CustomerVisitReservation',
      component: CustomerVisitReservation,
      meta: {
        title: '预约参观',
        authBindPhone: true,
      }
    },
    {
      path: '/customer/favorite/list',
      name: 'CustomerFavoriteList',
      component: CustomerFavoriteList,
      meta: {
        title: '我的收藏',
        authBindPhone: true,
      }
    },
    {
      path: '/mine/activity',
      name: 'MineActivity',
      component: MineActivity,
      meta: {
        title: '我的活动',
        authBindPhone: true,
      }
    },
    {
      path: '/customer/evaluate/edit',
      name: 'CustomerEvaluateEdit',
      component: CustomerEvaluateEdit,
      meta: {
        title: '修改评分',
      }
    },
    {
      path: '/onestop/company/list',
      name: 'OnestopCompanyList',
      component: OnestopCompanyList,
      meta: {
        title: '装修公司',
      }
    },
    {
      path: '/verifier/register',
      name: 'DealerVerifierRegister',
      component: DealerVerifierRegister,
      meta: {
        title: '注册核销人员',
        authBindPhone: false,
      }
    },
    {
      path: '/verify/coupon',
      name: 'DealerVerifyCoupon',
      component: DealerVerifyCoupon,
      meta: {
        title: '优惠券',
        authBindPhone: false,
      }
    }
  ]
})
